import { render, staticRenderFns } from "./GatePass.vue?vue&type=template&id=59e37c70&"
import script from "./GatePass.vue?vue&type=script&lang=js&"
export * from "./GatePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports